import React from 'react';

interface Props {
  id: string;
}

export default function AdminVideoPreview({ id }: Props) {
  if (!id) return null;

  return (
    <div className="mt-2">
      <iframe
        width="280"
        height="157"
        src={`https://www.youtube.com/embed/${id}`}
        title="YouTube video preview"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      />
    </div>
  );
}
